import { useAtomValue } from 'jotai';
import { createResourceAtom } from 'lib/atoms';
import { useMemo } from 'react';
import { FocusAreasResponse } from 'types/api-responses';
import { formatResource } from 'utils/misc';

interface FocusArea {
  name: string;
  id: string;
  /** The area's own colour; null/absent falls back to the category colour. */
  displayColor?: string | null;
}

interface FocusAreaCategory {
  name: string;
  id?: string;
  areas?: FocusArea[];
}

export const useFocusAreas = () => {
  const focusAreasResourceAtom = useMemo(
    () =>
      createResourceAtom<FocusAreasResponse>('/area_geometries/focus_areas'),
    []
  );

  const areasState = useAtomValue(focusAreasResourceAtom);

  const formattedAreas = formatResource(areasState);

  const categories: FocusAreasResponse['focusAreas']['boundaries'] =
    formattedAreas.data?.focusAreas.boundaries ?? [];

  const sharedCategories: FocusAreaCategory[] = categories
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((category) => ({
      ...category,
      areas: [...(category.areas ?? [])].sort((a, b) =>
        a.name.localeCompare(b.name)
      ),
    }));

  return {
    isLoading: formattedAreas.loading,
    sharedCategories,
  };
};
